import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { parseToBoolean } from "@faire/web-api--source/parseUtils";
/**
 * Factory for provisioning an EnvironmentStore with known keys
 * @example
 * ```
 * interface MyEnvironment { foo: string }
 * export const EnvironmentStore = EnvironmentFactory<MyEnvironment>();
 * ```
 */ export var EnvironmentFactory = function() {
    var EnvironmentStore = function EnvironmentStore() {
        "use strict";
        var _this = this;
        _class_call_check(this, EnvironmentStore);
        this.get = function(key) {
            var value = process.env["".concat(String(key))];
            if (typeof value === "undefined") {
                throw new Error("".concat(String(key), " not set in environment vars"));
            }
            return value;
        };
        this.getOrDefault = function(key, defaultValue) {
            var value = process.env["".concat(String(key))];
            if (typeof value === "undefined") {
                return defaultValue;
            }
            return value;
        };
        this.getBoolean = function(key) {
            var defaultValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "false";
            return parseToBoolean(_this.getOrDefault(key, defaultValue));
        };
    };
    EnvironmentStore.get = singletonGetter(EnvironmentStore);
    return EnvironmentStore;
};
